import React, { useEffect } from "react";

import { useNavigate } from "@reach/router";
import { fromLocalStorage, toLocalStorage } from "kanopi-components/utils/browser";
import { setBearer } from "kw/api";
import { useGlobal } from "kanopi-components/useGlobal";
import { useLocation } from "@reach/router";
import { parse } from "query-string";
import { Placeholder } from "kanopi-components/Placeholder";
import { useSsoVerification } from "kw/auth/hooks/useSsoVerification";

export function SsoSamlAuthenticatorSuccessRedirect() {
  const navigate = useNavigate();
  const [, setAuth] = useGlobal("auth");
  const location = useLocation();
  const searchParams = parse(location.search);
  const type = searchParams?.type
    ? searchParams?.type
    : fromLocalStorage("authenticator_type", "");
  const { verifySsoUser } = useSsoVerification(type);

  useEffect(() => {
    verifySsoUser(async (response) => {
      if (response?.ssoVerification?.token) {
        // SSO related key value pairs.
        toLocalStorage("is_sso", true);
        toLocalStorage("authenticator_type", type);

        // JWT related key value pairs for the internal default authentication.
        setBearer(response.ssoVerification?.token);
        toLocalStorage("auth", response.ssoVerification);
        await setAuth(response.ssoVerification);

        if (response.ssoVerification?.user?.allowAdminPortalAccess) {
          navigate("/admin");
        } else {
          navigate("/policies");
        }
      }
    });
  }, [type]);

  return <Placeholder loading={true} />;
}
